import destroyed from './destroyed'
import guard from './guard'
export default [
  guard,
  destroyed
]



// WEBPACK FOOTER //
// ./src/mixins/index.js